import React from "react";
import { isMobile } from "react-device-detect";
import styles from "./IntroducingFlashpay.module.scss";
import classNames from "classnames";

interface IntroducingFlashpayProps {
  isHongKongAccount?: boolean;
}

const IntroducingFlashpay: React.FC<IntroducingFlashpayProps> = props => {
  const isHK = props.isHongKongAccount;
  const learnMoreUrl = isHK
    ? "https://help.ipaymy.com/en/articles/8134491-how-do-i-get-the-next-day-s-payout-in-hong-kong"
    : "http://help.ipaymy.com/en/articles/8014167-how-do-i-get-the-next-day-s-payout-in-singapore";
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.isMobile]: isMobile
      })}
    >
      <div
        className={classNames(styles.topLayer, {
          [styles.HKFlashpayBanner]: isHK
        })}
      />
      <div className={styles.topLeft}>
        <p>
          <span>Introducing&nbsp;</span>
          <span>Flash Pay</span>
        </p>
        <p className={styles.description}>Get next-day payouts now</p>
      </div>
      <div className={styles.bottomLeft}>
        <a className={styles.learnMore} target="_blank" href={learnMoreUrl}>
          Learn more
        </a>
      </div>
    </div>
  );
};

export default IntroducingFlashpay;
